export default "__VITE_ASSET__af43e900__"